import { render, staticRenderFns } from "./TableColumn.vue?vue&type=template&id=5e44204c&scoped=true&"
import script from "./TableColumn.vue?vue&type=script&lang=js&"
export * from "./TableColumn.vue?vue&type=script&lang=js&"
import style0 from "./TableColumn.vue?vue&type=style&index=0&id=5e44204c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e44204c",
  null
  
)

export default component.exports